import React from 'react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import InstrumentSearchLookup from '../Models/InstrumentSearchLookup';
import AssignInstrumentComponentVM from './AssignInstrumentComponentVM';
import InstrumentMappingsLookup from '../Models/InstrumentMappingLookupModel';
import Loading from '../../../App/Components/Loading/Loading';
import SaveAndCancelButtons from '../../../Common/Components/SaveAndCancelButtons/SaveAndCancelButtons';
import ManageInstrumentComponent from '../../../Maintenance/Instruments/components/ManageInstrumentComponent';


interface IAssignInstrumentComponentProps {
    viewModel: AssignInstrumentComponentVM;
    instrumentMappingUpdateList: InstrumentMappingsLookup[];
    onBack: () => void;
    onSave: () => void;
    onInstrumentSearch: () => void;
}

@observer
export default class AssignInstrumentComponent extends React.Component<IAssignInstrumentComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;

        return (
            <div>
                {(viewModel.taskRunner.isBusy) && <Loading />}
                {
                <Neo.Modal 
                    title={TextConstants.Titles.AddInstrument}
                    bind={viewModel.meta.showOnTheFlyInstrumentModal}
                    footer={<></>}
                    size='lg'>
                    <ManageInstrumentComponent
                        viewModel={viewModel.manageInstrumentComponent}
                        onSave={() => viewModel.manageInstrumentComponent.managedInstrument.isValid ? viewModel.saveInstrument() : {}}
                        onCancel={() => viewModel.closeInstrumentModal()} />
                </Neo.Modal>
                }
                {<Neo.Card title={TextConstants.Titles.AssignInstrument}>
                    <div className="row p-3">
                        <NeoGrid.Grid items={this.props.instrumentMappingUpdateList} label={TextConstants.Titles.InstrumentMappingsToAssign}>
                            {(data, meta) => (
                                <NeoGrid.Row>
                                    <NeoGrid.Column display={meta.stockbroker} label={TextConstants.Labels.Broker} />
                                    <NeoGrid.Column display={meta.instrumentCode} />
                                    <NeoGrid.Column display={meta.description} label={TextConstants.Labels.InstrumentDescription} />
                                    <NeoGrid.Column display={meta.isin} label={TextConstants.Labels.Isin} />
                                    <NeoGrid.Column display={meta.instrumentType} />
                                    <NeoGrid.Column display={meta.instrumentSubType} />
                                    <NeoGrid.Column display={meta.exchange} />
                                    <NeoGrid.Column
                                        style={{textAlign: 'center'}}>    
                                        <Neo.Button
                                            size='sm'
                                            text={TextConstants.Labels.CreateAsInstrument}
                                            onClick={() => {viewModel.openInstrumentModal(data)}}
                                        />
                                    </NeoGrid.Column>
                                </NeoGrid.Row>
                            )}
                        </NeoGrid.Grid>
                    </div>

                    <Neo.Form model={viewModel.instrumentSearchCriteria} onSubmit={() => viewModel.instrumentSearchCriteria.searchCriteria === "" ? viewModel.pageManager.refreshData() : viewModel.clearSearch()}>
                        <Neo.FormGroup bind={viewModel.instrumentSearchCriteria.meta.searchCriteria}
                            onKeyUp={() => this.props.onInstrumentSearch()}
                            placeholder={TextConstants.PlaceHolder.SearchInstrument}
                            suppressLabel={true}
                            append={<Neo.Button isSubmit>
                                <i className={`${viewModel.instrumentSearchCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                            </Neo.Button>} />
                    </Neo.Form>

                    <Neo.Pager pageManager={viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show: " }}>
                        <NeoGrid.Grid<InstrumentSearchLookup> className={"table-striped"}>
                            {(data, meta) => (
                                <NeoGrid.Row>
                                    <NeoGrid.Column display={meta.description} />
                                    <NeoGrid.Column display={meta.isin} label={TextConstants.Labels.Isin} />
                                    <NeoGrid.Column display={meta.ticker} />
                                    <NeoGrid.Column bind={meta.isSelectedInd} input={{ type: "switch" }} onChange={() => { viewModel.selectInstrument(data) }} label={TextConstants.Labels.Assign} />
                                </NeoGrid.Row>
                            )}
                        </NeoGrid.Grid>
                    </Neo.Pager>
                    <SaveAndCancelButtons
                        onSave={() => this.props.onSave()}
                        onCancel={() => this.props.onBack()} />
                </Neo.Card>}
            </div>
        );
    }
}